// export default function HeroSection2() {
//     return (
//       <section className="relative py-20 md:py-32 bg-gradient-to-br from-primary-dark to-primary-base">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             {/* Decorative elements */}
//             <div className="mb-12 flex justify-center space-x-4">
//               <div className="w-16 h-1 bg-blue-300 rounded-full"></div>
//               <div className="w-8 h-1 bg-blue-300 rounded-full"></div>
//             </div>

import { Link } from "react-router-dom";

  
//             <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
//               <span className="block">Quality Offset &</span>
//               <span className="block text-blue-200 from-accent-base to-accent-light">Digital Printing</span>
//               <span className="block">Services</span>
//             </h1>
  
//             <div className="max-w-3xl mx-auto mb-12">
//               <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-inner">
//                 <p className="text-lg md:text-xl text-blue-50 font-body leading-relaxed">
//                   <span className="font-semibold text-white">Satyam</span>, a reputed name in printing since 2002. 
//                   As Ahmedabad's leading printing house, we deliver premium communication 
//                   materials for India's top companies.
//                 </p>
//               </div>
//             </div>
  
//             <div className="mt-10">
//               <button className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-semibold rounded-full text-blue-900 bg-white hover:bg-blue-50 hover:scale-105 transform transition-all duration-300 shadow-lg hover:shadow-xl">
//                 VIEW SERVICES
//                 <svg 
//                   className="ml-2 -mr-1 h-5 w-5" 
//                   fill="currentColor" 
//                   viewBox="0 0 20 20"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//               </button>
//             </div>
  
//             {/* Experience badge */}
//             <div className="mt-16 inline-block bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm">
//               <span className="text-sm font-semibold text-blue-100 tracking-wide">
//                 TRUSTED SINCE 2002 • AHMEDABAD BASED • BLUE-CHIP PARTNER
//               </span>
//             </div>
//           </div>
//         </div>
//   </section>
//     )
//   }

// export default function HeroSection() {
//   return (
//     <section className="relative py-20 md:py-32 bg-primary-900">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center">
//           <div className="mb-12 flex justify-center space-x-4">
//             <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
//             <div className="w-8 h-1 bg-accent-500 rounded-full"></div>
//           </div>

//           <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-primary-100 leading-tight mb-8">
//             <span className="block">Quality Offset &</span>
//             <span className="block text-accent-400">Digital Printing</span>
//             <span className="block">Services</span>
//           </h1>

//           <div className="max-w-3xl mx-auto mb-12">
//             <div className="bg-primary-800/60 backdrop-blur-sm rounded-xl p-6 shadow-inner">
//               <p className="text-lg md:text-xl text-primary-100 font-body leading-relaxed">
//                 <span className="font-semibold text-accent-300">Satyam</span>, a reputed name in printing since 2002. 
//                 As Ahmedabad's leading printing house, we deliver premium communication 
//                 materials for India's top companies.
//               </p>
//             </div>
//           </div>

//           <div className="mt-10">
//             <button className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-semibold rounded-full text-primary-900 bg-accent-500 hover:bg-accent-600 hover:scale-105 transform transition-all duration-300 shadow-lg hover:shadow-xl">
//               VIEW SERVICES
//               <svg className="ml-2 -mr-1 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
//                 <path
//                   fillRule="evenodd"
//                   d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//             </button>
//           </div>

//           <div className="mt-16 inline-block bg-primary-800/40 px-6 py-3 rounded-full backdrop-blur-sm">
//             <span className="text-sm font-semibold text-primary-200 tracking-wide">
//               TRUSTED SINCE 2002 • AHMEDABAD BASED • BLUE-CHIP PARTNER
//             </span>
//           </div>
//         </div>
//       </div>
//     </section>
//   )
// }

// export default function HeroSection() {
//     return (
//       <section className="relative py-20 md:py-32 bg-gradient-to-br from-primary-900 to-primary-700">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             <div className="mb-12 flex justify-center space-x-4">
//               <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
//               <div className="w-8 h-1 bg-accent-500 rounded-full"></div>
//             </div>
  
//             <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-primary-50 leading-tight mb-8">
//               <span className="block">Premium Offset &</span>
//               <span className="block text-accent-300">Digital Printing</span>
//               <span className="block">Solutions</span>
//             </h1>
  
//             <div className="max-w-3xl mx-auto mb-12">
//               <div className="bg-primary-900/60 backdrop-blur-sm rounded-xl p-6 shadow-inner">
//                 <p className="text-lg md:text-xl text-primary-100 font-body leading-relaxed">
//                   <span className="font-semibold text-accent-300">Satyam</span>, 
//                   Ahmedabad's trusted printing partner since 2002. Delivering 
//                   exceptional print solutions for India's leading organizations.
//                 </p>
//               </div>
//             </div>
  
//             <div className="mt-10">
//               <button className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-semibold rounded-full text-primary-900 bg-accent-500 hover:bg-accent-600 hover:scale-105 transform transition-all duration-300 shadow-lg hover:shadow-xl">
//                 EXPLORE SERVICES
//                 <svg className="ml-2 -mr-1 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
//                   <path
//                     fillRule="evenodd"
//                     d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//               </button>
//             </div>
  
//             <div className="mt-16 inline-block bg-primary-700/40 px-6 py-3 rounded-full backdrop-blur-sm">
//               <span className="text-sm font-semibold text-primary-200 tracking-wide">
//                 TRUSTED SINCE 2002 • 5000+ SATISFIED CLIENTS • ISO CERTIFIED
//               </span>
//             </div>
//           </div>
//         </div>
//       </section>
//     )
//   }

// export default function HeroSection() {
//     return (
//       <section className="relative min-h-screen flex items-center bg-gradient-to-br from-primary-dark to-primary-base">
//         <div className="absolute inset-0 pattern-dots pattern-primary-base pattern-opacity-10 pattern-size-4" />
        
//         <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
//           <div className="mb-16 animate-fade-in">
//             <div className="inline-block mb-12 border-2 border-accent-base p-4 rounded-full">
//               <span className="text-accent-base font-body font-semibold tracking-widest">
//                 SINCE 2002
//               </span>
//             </div>
  
//             <h1 className="text-5xl md:text-7xl font-heading text-neutral-light leading-tight mb-8">
//               <span className="block mb-6">Precision</span>
//               <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
//                 Printing Excellence
//               </span>
//             </h1>
  
//             <div className="max-w-2xl mx-auto mb-16">
//               <p className="text-xl text-neutral-light/90 font-body leading-relaxed">
//                 Crafting bespoke print solutions for discerning clients through 
//                 innovative technology and artisanal craftsmanship
//               </p>
//             </div>
  
//             <div className="flex justify-center gap-6">
//               <button className="button-primary">
//                 Explore Services
//                 <div className="h-5 w-5 ml-2 transition-transform group-hover:translate-x-1" />
//               </button>
//               <button className="button-secondary">
//                 View Portfolio
//               </button>
//             </div>
//           </div>
  
//           <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
//             <div className="h-12 w-12 text-accent-base" />
//           </div>
//         </div>
//       </section>
//     )
//   }

export default function HeroSection2() {
  return (
    <section className="relative py-20 md:py-40 bg-gradient-to-br from-primary-dark to-primary-base">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Decorative elements */}
          <div className="mb-12 flex justify-center space-x-4">
            <div className="w-16 h-1 bg-accent-base rounded-full"></div>
            <div className="w-8 h-1 bg-accent-light rounded-full"></div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
            <span className="block">Quality Offset &</span>
          
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
              Digital Printing
            </span>
            <span className="block">Services</span>
          </h1>

          <div className="max-w-3xl mx-auto mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-inner">
              <p className="text-lg md:text-xl text-blue-50 font-body leading-relaxed">
                <span className="font-semibold text-white">Capital Offset</span>, a reputed name in the printing industry, We specialize in delivering premium communication materials for India's top companies. Our commitment to quality and precision sets us apart.
              </p>
            </div>
          </div>

          <div className="mt-10">
          <Link to="/services">
            <button className="inline-flex items-center px-8 py-4 border-2 border-accent-base font-semibold rounded-full text-accent-base hover:scale-105 transform transition-all duration-300 shadow-lg hover:shadow-xl">
              VIEW SERVICES
              <svg 
                className="ml-2 -mr-1 h-5 w-5" 
                fill="currentColor" 
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            </Link>
          </div>
        
          {/* Experience badge */}
          <div className="mt-16 inline-block bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm">
            <span className="text-sm font-semibold text-blue-100 tracking-wide">
            TRUSTED LEADER IN PRINTING | PREMIUM QUALITY SOLUTIONS | EXCELLENCE IN EVERY PROJECT            </span>
          </div>
        </div>
      </div>
</section>
  )
}